<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <!-- The per-page title + breadcrumb trail now render together in the
           navbar itself (see `PageTitle.vue`), so the old row-2
           `AppBreadcrumb` block that duplicated the page title here has
           been removed. The `breadcrumb` slot is kept (now empty by
           default) so any page that still passes explicit slot content
           for this spot continues to work unchanged. -->
      <slot name="breadcrumb" />
      <div class="content-body">
        <transition
          :name="routerTransition"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'

export default {
  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    return {
      routerTransition, contentWidth,
    }
  },
}
</script>

<style>

</style>
